export default import.meta.ROLLUP_FILE_URL_pM8t5DGavds60SaZr2TP1w